import React from 'react';
import loader from './assets/loader.gif';

function ImageLoader() {
  return <img src={loader} alt="loading" role="presentation" />;
}

export default ImageLoader;
